import React, { useCallback, useEffect } from "react";
import { translate } from "@td/shared_utils";
import {
  FiltersClearButton,
  FiltersContainer,
  FiltersLabel,
} from "@td/ui";
import {
  AssignedToFilter,
  CategoryFilter,
  ConsultDateFilter,
  DueDateFilter,
  MemberFilter,
  PriorityFilter,
  StatusFilter,
  TaskTypeFilter,
} from "../filters";
import { useTasks } from "../contexts/tasks-context";
import { defaultFilters, filterTypes } from "../constants";
import { useFiltersPreload } from "../hooks";

const Filters = React.memo(() => {
  const { preloadFilters } = useFiltersPreload();
  const { filters, updateFilters, resetFilters } = useTasks();

  useEffect(() => {
    preloadFilters();
  }, []);

  const handleChange = useCallback((name) => (value) => {
    updateFilters({ [name]: value });
  }, [updateFilters]);

  const handleCategoryChange = useCallback((value) => {
    updateFilters({
      ...defaultFilters,
      [filterTypes.CATEGORY]: value,
    });
  }, []);

  return (
    <React.Fragment>
      <CategoryFilter
        value={filters[filterTypes.CATEGORY]}
        onChange={handleCategoryChange}
      />

      <FiltersContainer>
        <FiltersLabel>
          {translate(null, "care_team_tasks.filters", "label")}:
        </FiltersLabel>

        <TaskTypeFilter
          value={filters[filterTypes.TYPES]}
          onChange={handleChange(filterTypes.TYPES)}
        />
        <AssignedToFilter
          value={filters[filterTypes.ASSIGNEES]}
          onChange={handleChange(filterTypes.ASSIGNEES)}
        />
        <MemberFilter
          value={filters[filterTypes.MEMBERS]}
          onChange={handleChange(filterTypes.MEMBERS)}
        />
        <ConsultDateFilter
          value={filters[filterTypes.CONSULT_DATE]}
          onChange={handleChange(filterTypes.CONSULT_DATE)}
        />
        <DueDateFilter
          value={filters[filterTypes.DUE_DATE]}
          onChange={handleChange(filterTypes.DUE_DATE)}
        />
        <PriorityFilter
          value={filters[filterTypes.PRIORITIES]}
          onChange={handleChange(filterTypes.PRIORITIES)}
        />
        <StatusFilter
          value={filters[filterTypes.STATUSES]}
          onChange={handleChange(filterTypes.STATUSES)}
        />

        <FiltersClearButton
          onClick={resetFilters}
        >
          {translate(null, "care_team_tasks.filters", "clear_all")}
        </FiltersClearButton>
      </FiltersContainer>
    </React.Fragment>
  );
});

export default Filters;
